'use strict';

var baseLogin = require('base/login/login');
var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');

/**
 * Validates the reCAPTCHA for the given form and action.
 * Executes the callback function if reCAPTCHA is valid.
 *
 * @param {jQuery} form - The form element to validate.
 * @param {string} action - The action for reCAPTCHA validation (e.g., 'login', 'signup').
 * @param {Function} callback - The callback function to execute after reCAPTCHA validation.
 */
function validateRecaptcha(form, action, callback) {
    // Skip reCAPTCHA validation if not enabled
    if (!window.recaptchaPlugin || !window.recaptchaPlugin.ENABLED || !window.recaptchaPlugin.executeCaptcha) {
        return callback();
    }

    // Execute reCAPTCHA and handle the promise
    window.recaptchaPlugin.executeCaptcha(form, action).then(callback).catch(function () {
        form.spinner().stop();
    });
}

// Extend the login functionality
baseLogin.login = function () {
    // Re-enable login button only after JS has loaded and submit handler is registered
    // Prevents native form submission (raw JSON in browser) on slow 3G/4G connections
    $('.login-btn').prop('disabled', false).removeAttr('aria-disabled');

    $('form.login').submit(function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        // Validate reCAPTCHA & then submit the form
        validateRecaptcha(form, 'login', function () {
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    } else {
                        $('form.login').trigger('login:success', data);
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
        });

        return false;
    });
};

$('.select-purchaseType-input').on('change', function () {
    if ((this.value) == 'Individual') {
        $('.register-form-content-container').show();
        $('.business-form-content-container').hide();
    } else {
        $('.register-form-content-container').hide();
        $('.business-form-content-container').show();
    }
});

$('#heroImageMyTab').find('.nav-btn').on('click', function () {
    if ($(this).attr('aria-controls') == 'register') {
        $('#purchaseType-individual').prop("checked", true);
        $('.register-form-content-container').show();
        $('.business-form-content-container').hide();
    }
});

// Extend the register functionality
baseLogin.register = function () {
    $('form.registration').submit(function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();

        // Validate reCAPTCHA & then submit the form
        validateRecaptcha(form, 'signup', function () {
            $('form.registration').trigger('login:register', e);
            var separator = url.indexOf('?') >= 0 ? '&' : '?';
            url += `${separator}ischeckout=${encodeURIComponent($('input[name="coregister"]').val() || null)}`;
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $('form.registration').trigger('login:register:error', data);
                        formValidation(form, data);
                    } else {
                        $('form.registration').trigger('login:register:success', data);
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }

                    form.spinner().stop();
                }
            });
        });

        return false;
    });
};

// Extend the resetPassword functionality
baseLogin.resetPassword = function () {
    $('.reset-password-form').off('submit').on('submit', function(e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $('.reset-password-form').trigger('login:register', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    formValidation(form, data);
                } else {
                    var html = '<p class="email-sent">' + "Email sent." + '</p>' + '<p class="email-sent-msg">' + data.receivedMsgBody + '</p>';
                    $('.request-password-body').empty().append(html);
                    $('.send-email-btn').addClass('d-none');
                    $('.backToHondaBtn').removeClass('d-none');
                    $('.reset-password-link-expire-info').addClass('d-none');
                    if (!data.mobile) {
                        $('#submitEmailButton').text(data.buttonText)
                            .attr('data-dismiss', 'modal');
                    } else {
                        $('.send-email-btn').empty()
                            .html('<a href="' +
                                data.returnUrl +
                                '" class="btn btn-primary btn-block">' +
                                data.buttonText + '</a>');
                    }
                }
            },
            error: function () {
                form.spinner().stop();
            }
        });
        return false;
    });
};

baseLogin.validateInput = function () {
    const regexData = {
        EIGHT_CHARACTER: /^.{8,}$/,
        AT_LEAST_ONE_NUM: /^(?=.*\d).+$/,
        UPPER_AND_LOWER: /^(?=.*[a-z])(?=.*[A-Z]).+$/,
        SPECIAL_CHARS: /^(?=.*[^a-zA-Z0-9]).+$/
    }
    $('#registration-form-password').on('keyup', () => {
        var $this = $('#registration-form-password');
        if($this.val()){
           var regex = regexData.EIGHT_CHARACTER;
           var ele = $('.eight-char');
           if (regex.test($this.val())) {
                ele.addClass('color--success-60').removeClass('color--nutral-90, color--error-60').find('.icon.icon-check').removeClass('d-none');
                ele.find('.icon.icon-close').addClass('d-none')
           } else {
                ele.find('.icon.icon-check').addClass('d-none');
                ele.addClass('color--error-60').removeClass('color--nutral-90, color--success-60').find('.icon.icon-close').removeClass('d-none')
           }
           var regex = regexData.AT_LEAST_ONE_NUM;
           var ele = $('.one-number');
           if (regex.test($this.val())) {
                ele.addClass('color--success-60').removeClass('color--nutral-90, color--error-60').find('.icon.icon-check').removeClass('d-none');
                ele.find('.icon.icon-close').addClass('d-none')
           } else {
                ele.find('.icon.icon-check').addClass('d-none');
                ele.addClass('color--error-60').removeClass('color--nutral-90, color--success-60').find('.icon.icon-close').removeClass('d-none')
           }
           var regex = regexData.UPPER_AND_LOWER;
           var ele = $('.upper-and-lower');
           if (regex.test($this.val())) {
                ele.addClass('color--success-60').removeClass('color--nutral-90, color--error-60').find('.icon.icon-check').removeClass('d-none');
                ele.find('.icon.icon-close').addClass('d-none')
           } else {
                ele.find('.icon.icon-check').addClass('d-none');
                ele.addClass('color--error-60').removeClass('color--nutral-90, color--success-60').find('.icon.icon-close').removeClass('d-none')
           }
           var regex = regexData.SPECIAL_CHARS;
           var ele = $('.special-char');
           if (regex.test($this.val())) {
                ele.addClass('color--success-60').removeClass('color--nutral-90, color--error-60').find('.icon.icon-check').removeClass('d-none');
                ele.find('.icon.icon-close').addClass('d-none')
           } else {
                ele.find('.icon.icon-check').addClass('d-none');
                ele.addClass('color--error-60').removeClass('color--nutral-90, color--success-60').find('.icon.icon-close').removeClass('d-none')
           }
        } else {
            $('.eight-char').addClass('color--nutral-90').removeClass('color--error-60, color--success-60').find('.icon.icon-check, .icon.icon-close').addClass('d-none');
            $('.one-number').addClass('color--nutral-90').removeClass('color--error-60, color--success-60').find('.icon.icon-check, .icon.icon-close').addClass('d-none');
            $('.upper-and-lower').addClass('color--nutral-90').removeClass('color--error-60, color--success-60').find('.icon.icon-check, .icon.icon-close').addClass('d-none');
            $('.special-char').addClass('color--nutral-90').removeClass('color--error-60, color--success-60').find('.icon.icon-check, .icon.icon-close').addClass('d-none');

        }
    });
};

baseLogin.confirmPassword = function () {
    $('#registration-form-password-confirm').on('keyup', () => {
        var $this = $('#registration-form-password-confirm');
        var password = $('#registration-form-password');
        if(password.val() === $this.val()){
            $('.confirm-password-match').removeClass('d-none').addClass('d-flex');
            $('#form-password-confirm-error').removeClass('invalid-feedback').empty();
        } else {
            $('.confirm-password-match').removeClass('d-flex').addClass('d-none');
            $('#form-password-confirm-error').addClass('invalid-feedback').html('Does not match password');
        }
    })
};
// Export the extended module
module.exports = baseLogin;
